import { render, staticRenderFns } from "./DocsGovernanceOverview.vue?vue&type=template&id=7b99fb16&scoped=true"
import script from "./DocsGovernanceOverview.vue?vue&type=script&lang=js"
export * from "./DocsGovernanceOverview.vue?vue&type=script&lang=js"
import style0 from "./DocsGovernanceOverview.vue?vue&type=style&index=0&id=7b99fb16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b99fb16",
  null
  
)

export default component.exports